import Client from './client';

export default class BrickWebhookEvents extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getByFtpFolderId(ftpFolderId, options = {}) {
    return this.makeRequest(`${this.host}/ftp/webhook/events/brickftp/${ftpFolderId}`, options);
  }

}
